/**
 * Hebrew display labels for the fixed server enums (root roles, subscription statuses). These are
 * closed sets defined by the backend contract; unknown values pass through unchanged so a new enum
 * value degrades to its raw id rather than vanishing. Dynamic identifiers (planId, productId,
 * module role ids) are NOT translated — they are technical ids, not UI copy.
 */

export function roleLabel(role: string): string {
  switch (role) {
    case 'owner':
      return 'בעלים';
    case 'admin':
      return 'מנהל';
    case 'member':
      return 'חבר';
    default:
      return role;
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'active':
      return 'פעיל';
    case 'on_trial':
      return 'בתקופת ניסיון';
    case 'past_due':
      return 'תשלום באיחור';
    case 'unpaid':
      return 'לא שולם';
    case 'cancelled':
      return 'בוטל';
    case 'expired':
      return 'פג תוקף';
    default:
      return status;
  }
}
